import React, { useMemo } from 'react';

import { CardGroup, ImageCard, Text } from '@/components/ui';

export function OrganizationTypeForm ({ form }) {
    const selectedType = form.watch('organizationType');

    const options = useMemo(() => [
        {
            title: i18next.t('organizations.type.building'),
            organizationType: 'building',
            description: i18next.t('organizations.type.building_desc')
        },
        {
            title: i18next.t('organizations.type.retail'),
            organizationType: 'retail',
            description: i18next.t('organizations.type.retail_desc')
        },
        {
            title: i18next.t('organizations.type.industry'),
            organizationType: 'industry',
            description: i18next.t('organizations.type.industry_desc')
        }
    ], []);

    return (
        <div className="tw-flex tw-h-full tw-items-center">
            <CardGroup columns={3}>
                {options.map((option, index) => {
                    const isSelected = option.organizationType === selectedType;

                    return (
                        <ImageCard
                            key={index}
                            image={(
                                <img
                                    alt={option.title}
                                    src={`/images/misc/${option.organizationType}.png`}
                                    className="tw-h-auto tw-object-contain"
                                />
                            )}
                            interactive
                            onClick={() => form.setValue('organizationType', option.organizationType, { shouldValidate: true })}
                            title={option.title}
                            tone={isSelected ? 'primary' : 'neutral'}
                        >
                            <Text tone="inherit" variant="body-sm">
                                {option.description}
                            </Text>
                        </ImageCard>
                    );
                })}
            </CardGroup>
        </div>
    );
}
